import ApiService from "services/ApiService";

const JourneyService = {
    getJourneyById: async function (id) {
        const endpoint = `/journeys/${id}`;
        return await ApiService.get(endpoint);
    },
    getJourneyTestCases: async function ({ journeyId, page = 1, limit = 10, searchQuery = '', sortConfig = { key: 'created_at', direction: 'desc' } }) {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (searchQuery) params.append("search", searchQuery);
        if (sortConfig?.key) params.append("sort_key", sortConfig.key);
        if (sortConfig?.direction) params.append("sort_direction", sortConfig.direction);
        const query = params.toString();
        const endpoint = query
            ? `/journeys/test-cases/${journeyId}?${query}`
            : `/journeys/test-cases/${journeyId}`;
        return await ApiService.get(endpoint);
    },
};

export default JourneyService;
